import request from "../utils/request";

export const getOrders = '/consignment/order/';

export const exportOrderUrl = '/consignment/order/exportConsignmentOrder'

export function getOrder(orderId: number) {
    return request.get('/consignment/order/detail', {params: {orderId}});
}

export function submitOrder(orderId: number) {
    return request.post('/consignment/order/submit', {orderId});
}

export function modifyOrder(values: any) {
    return request.post('/consignment/order/modifyConsignmentOrder', values);
}

export function closeOrder(orderId:any){
    return request.put('/consignment/order/close', {orderId});
}

export function completeOrder(values: any) {
    return request.post('/consignment/order/complete', values);
}

export function sendOAApproval(orderId: number) {
    return request.request({method: "get", url: "/consignment/order/sendOAApproval", params: {orderId: orderId}})
}

export function erpSync(orderId: number) {
    return request.request({method: "get", url: "/consignment/order/syncErp", params: {orderId: orderId}})
}

export const getOrderLines = '/consignment/order/line';

export const exportOrderLinesUrl = '/consignment/order/exportLine';

export function contactOrder(params:any){
    return request.post('/consignment/order/contact', params);
}
